import IService from '../IService';

export default IService.extend({
  getVoices: function (organizationId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(
          '/api/v1/text2speech/voices/organizations?orgId=' + organizationId
        ),
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        error: function (xhr) {
          reject(xhr.responseJSON?.message || xhr.responseText);
        },
        success: function (response) {
          if (response && response.voices?.length) {
            resolve(response);
          } else {
            reject('No voices found');
          }
        },
      });
    });
  },
  create(options = { storyId: null, text: null, voiceId: null }) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/text2speech/story/${options.storyId}`),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          text: options.text,
          voiceId: options.voiceId,
          options: {
            speed: options.speed,
          },
        }),
        dataType: 'json',
        error: function (xhr) {
          reject(xhr.responseJSON?.message || xhr.responseText);
        },
        success: function (response) {
          if (
            response &&
            response.assetUUID &&
            response.status === 'IN_PROGRESS'
          ) {
            resolve(response.assetUUID);
          } else {
            reject(
              response.errorMessage || 'Error while creating AI voice over'
            );
          }
        },
      });
    });
  },
});
